import { render, staticRenderFns } from "./AppointmentsCreating.vue?vue&type=template&id=979f7f46"
import script from "./AppointmentsCreating.vue?vue&type=script&lang=js"
export * from "./AppointmentsCreating.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsCreating.vue?vue&type=style&index=0&id=979f7f46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports